import * as React from 'react'

import Svg, {
  Circle,
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

const RegistrationFormCheck = (props) => (
  <Svg width={68} height={75} fill="none" {...props}>
    <G clipPath="url(#a)">
      <Path
        fill="#AFCDFF"
        d="M58.053 6.405 19.439.295c-1.346-.212-2.608.728-2.817 2.1L8.237 57.455c-.21 1.373.713 2.658 2.06 2.872l38.613 6.109c1.347.213 2.609-.727 2.818-2.1l8.385-55.058c.21-1.373-.713-2.659-2.06-2.872Z"
      />
      <Path
        fill="url(#b)"
        d="M49.403 7.965H10.328c-1.364 0-2.469 1.126-2.469 2.515v55.718c0 1.39 1.105 2.516 2.469 2.516h39.075c1.363 0 2.468-1.127 2.468-2.516V10.48c0-1.389-1.105-2.515-2.468-2.515Z"
      />
      <Path
        fill="#F65E5E"
        d="M47.214 58.696c0 3.05-2.425 5.52-5.416 5.52-2.992 0-5.416-2.47-5.416-5.52 0-3.05 2.424-5.52 5.416-5.52 2.991 0 5.416 2.47 5.416 5.52Z"
      />
      <Path
        fill="#fff"
        d="M13.34 18.87c0-1.17 0-1.755.237-2.198a2 2 0 0 1 .818-.817c.442-.238 1.028-.238 2.198-.238h26.03c1.17 0 1.755 0 2.198.238a2 2 0 0 1 .817.817c.238.443.238 1.028.238 2.199 0 1.17 0 1.756-.238 2.199a2 2 0 0 1-.817.817c-.443.237-1.028.237-2.199.237H16.593c-1.17 0-1.756 0-2.198-.237a2 2 0 0 1-.818-.817c-.237-.443-.237-1.029-.237-2.2ZM13.34 30.586c0-1.171 0-1.756.237-2.2a2 2 0 0 1 .818-.816c.442-.238 1.028-.238 2.198-.238h26.03c1.17 0 1.755 0 2.198.238a2 2 0 0 1 .817.817c.238.443.238 1.028.238 2.199 0 1.17 0 1.756-.238 2.199a2 2 0 0 1-.817.817c-.443.237-1.028.237-2.199.237H16.593c-1.17 0-1.756 0-2.198-.237a2 2 0 0 1-.818-.817c-.237-.443-.237-1.029-.237-2.2ZM13.34 42.297c0-1.171 0-1.756.237-2.2a2 2 0 0 1 .818-.816c.442-.238 1.028-.238 2.198-.238H30.91c1.17 0 1.756 0 2.199.238a2 2 0 0 1 .817.817c.238.443.238 1.028.238 2.199 0 1.17 0 1.756-.238 2.198a2 2 0 0 1-.817.818c-.443.237-1.028.237-2.199.237H16.593c-1.17 0-1.756 0-2.198-.237a2 2 0 0 1-.818-.818c-.237-.442-.237-1.028-.237-2.198Z"
      />
    </G>
    <Circle cx={43.663} cy={60.501} r={14.337} fill="url(#c)" />
    <Path
      fill="#fff"
      d="m48.289 55.387-7.322 7.285-2.605-2.592a1.391 1.391 0 0 0-1.957 0c-.54.537-.54 1.411 0 1.948l3.591 3.573c.262.261.617.399.987.399s.724-.138.986-.399l8.293-8.25c.54-.538.54-1.412 0-1.948a1.391 1.391 0 0 0-1.958 0l-.015-.016Z"
    />
    <Defs>
      <RadialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-37.16345 55.01626 -47.46231 -32.06076 48.523 11.92)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <RadialGradient
        id="c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-25.20865 26.87549 -23.42436 -21.97156 53.465 47.874)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FFE0B9" />
        <Stop offset={1} stopColor="#DCAD70" />
      </RadialGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M.163 0h67.674v68.976H.163z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default RegistrationFormCheck
